import { Injectable, NgZone } from '@angular/core';
import { PlatformService } from '@core/services/platform.service';
import { DestroyableComponent } from '@models/destroyable.component';
import { ErrorNotificationService } from '@shared/error-notification/error-notification.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CurrencyNotifierService extends DestroyableComponent {
  private showCurrencyAlertForce = this.register(new BehaviorSubject<boolean>(null));
  public showCurrencyAlertForce$ = this.showCurrencyAlertForce.asObservable();

  constructor(
    public errorNotificationService: ErrorNotificationService,
    public deviceService: DeviceDetectorService,
    private zone: NgZone,
    protected platform: PlatformService,
  ) {
    super(platform);
  }

  public showCurrencyNotifierForce() {
    this.showCurrencyAlertForce.next(true);
  }
}
